var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAllBounces = function SvgAllBounces(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64156 1.48684H4.28493C3.04759 1.48684 2.42892 1.48684 1.95632 1.72778C1.5406 1.93971 1.20262 2.27787 0.990803 2.69381C0.75 3.16667 0.75 3.78567 0.75 5.02368V11.2132C0.75 12.4512 0.75 13.0702 0.990803 13.543C1.20262 13.959 1.5406 14.2971 1.95632 14.5091C2.42892 14.75 3.04759 14.75 4.28493 14.75H10.4711C11.7084 14.75 12.3271 14.75 12.7997 14.5091C13.2154 14.2971 13.5534 13.959 13.7652 13.543C14.006 13.0702 14.006 12.4512 14.006 11.2132V8.85526M7.378 5.17105H10.3238V8.11842M9.95556 1.85526V0.75M12.8567 2.6368L13.6378 1.85526M13.6453 5.53947H14.75M0.75 9.11102C1.23012 9.1852 1.72201 9.22368 2.22289 9.22368C5.4532 9.22368 8.30985 7.62296 10.0437 5.17105",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAllBounces, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/all-bounces.f38a7d68.svg";
export { ForwardRef as ReactComponent };